var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tabs',{model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('el-tab-pane',{attrs:{"label":_vm.$t('audit.old_version'),"name":"oldView"}},[(_vm.activeTab === 'oldView')?_c('p',[_c('OldMainView')],1):_vm._e()]),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":_vm.$t('audit.new_version'),"name":"newView"}},[(_vm.activeTab === 'newView')?_c('p',[_c('MainView')],1):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-422573a2","hasScoped":false,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/audit/index.vue
// module id = 1468
// module chunks = 62